<template>
	<div class="widget-content">
		<iframe :src="widget.settings.url" />
	</div>
</template>

<script>
export default {
    name: 'WidgetView',
	props: {
		widget: Object
	}
}
</script>

<style lang="scss" scoped>
.widget {

	&-content {

		height: 100%;
		position: relative;
		width: 100%;

		&:after {
			content: '';
			height: 100%;
			@include position($position: absolute, $top: 0, $left: 0);
			width: 100%;
			z-index: 2;
		}

		iframe {
			border: 0;
			height: 100%;
			width: 100%;
		}

	}

}
</style>
